import React, { useState } from "react";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";

function Safety() {
  const [isMobile] = useState(window.innerWidth <= 768);

  const principles = [
    "Verified account and profile information wherever possible",
    "Secure checkout and payment processing",
    "Clear booking details and service pricing",
    "Support channels for reporting issues",
    "Ongoing monitoring to reduce fraudulent behavior",
  ];

  return (
    <>
      <CustomerHeader />
      <div
        style={{
          padding: isMobile ? "86px 16px 30px" : "106px 32px 42px",
          background: "#f9fafb",
        }}
      >
        <div
          style={{
            maxWidth: "980px",
            margin: "0 auto",
            background: "white",
            borderRadius: "16px",
            padding: isMobile ? "24px" : "40px",
            border: "1px solid #e5e7eb",
          }}
        >
          <h1 style={{ marginTop: 0, color: "#111827" }}>Safety on OGESTYLE</h1>
          <p style={{ color: "#4b5563", lineHeight: "1.7" }}>
            Trust and safety are core to the platform. We continually improve the way
            customers, businesses, and professionals interact safely.
          </p>

          <ul style={{ marginTop: "20px", color: "#374151", lineHeight: "1.9" }}>
            {principles.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>

          <p style={{ marginTop: "20px", color: "#6b7280", fontSize: "14px" }}>
            If you notice suspicious activity, report it through our contact channels immediately.
          </p>
        </div>
      </div>
      <CustomerFooter />
    </>
  );
}

export default Safety;
